import styles from './ConversationBubble.module.scss'

export const swayBotRegex = /automation directful|directbot/i

const Initials = ({ senderName }) => {
  if (!senderName) {
    return (
      <div data-tip={senderName} className={styles.initials}>
        ?
      </div>
    )
  }

  return (
    <div data-tip={senderName} className={styles.initials}>
      {senderName
        .split(' ')
        .map((n, i, a) => (i === 0 || i + 1 === a.length ? n[0] : null))
        .join('')}
    </div>
  )
}

export default Initials
